import { render } from "./BaseDisabledTextarea.vue?vue&type=template&id=cb863d8a&scoped=true"
import script from "./BaseDisabledTextarea.vue?vue&type=script&lang=js"
export * from "./BaseDisabledTextarea.vue?vue&type=script&lang=js"

import "./BaseDisabledTextarea.vue?vue&type=style&index=0&id=cb863d8a&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb863d8a"]])

export default __exports__